
import React, { Fragment as F, useContext, useEffect, useState } from 'react'

import {
  appRouter,
  C,
  logg,
  useApiRouter,
} from '$shared'
import { AppCtx } from "$src/App"

// import ListModal from './ListModal'
import ListsModal from './ListsModal'

import ImportListModal from './ImportListModal'

import QueryModal from './QueryModal'
import QueriesCtx from './QueriesCtx'
import QueriesModal from './QueriesModal'

const defaultSavedQuery = { name: '', is_merge: false, is_shared: false, shared_with_str: '' }

/**
 * QueriesProvider
**/
const QueriesProvider = ({ children, ...props }) => {

  /* ctx */

  const apiRouter = useApiRouter()

  const {
    jwtToken,
    loading, setLoading,
  } = useContext(AppCtx)

  /* state */

  const [ importListModalOpen, setImportListModalOpen ] = useState(false)

  const [ list, setList ] = useState({ name: '' })
  const [ listsModalOpen, setListsModalOpen ] = useState(false)

  const [ myListsList, setMyListsList ] = useState([])

  const [ queriesList, setQueriesList ] = useState([])
  const [ queryModalOpen,     setQueryModalOpen  ] = useState(false)
  const [ queriesModalOpen,   setQueriesModalOpen ] = useState(undefined === props.defaultQueriesModalOpen ? false : props.defaultQueriesModalOpen)

  const [ savedQuery,         setSavedQuery ] = useState(defaultSavedQuery)
  const [ saveQueryModalOpen, setSaveQueryModalOpen ] = useState(false)
  const [ selectedQueryId,    setSelectedQueryId ] = useState(false)
  const [ selectedQueries,    setSelectedQueries ] = useState({})

  const [ shareModalOpen, setShareModalOpen ] = useState(false)

  /* effects */

  /* get lists and queries */
  useEffect(() => {
    if (!jwtToken) { return; }
    refreshQueriesList()
  }, [ jwtToken ])


  /* methods */
  const refreshQueriesList = async () => {
    if (!jwtToken) { return; }
    setLoading(true)

    const one = fetch(apiRouter.queriesPath()).then(r => r.json()).then(inns => {
      // logg(inns, 'got saved Queries')
      setQueriesList(inns)
    })
    // only for adding-to, removing-from
    const two = fetch(apiRouter.myListsPath()).then(r => r.json()).then(inns => {
      setMyListsList(inns)
    })
    await one
    await two
    setLoading(false)
  }



  return <QueriesCtx.Provider value={{
    importListModalOpen, setImportListModalOpen,

    list,           setList,
    listsModalOpen, setListsModalOpen,

    myListsList,    setMyListsList,

    queriesList,      setQueriesList,      refreshQueriesList,
    queryModalOpen,   setQueryModalOpen,
    queriesModalOpen, setQueriesModalOpen,

    savedQuery,         setSavedQuery,
    selectedQueryId,    setSelectedQueryId,
    selectedQueries,    setSelectedQueries,
    saveQueryModalOpen, setSaveQueryModalOpen,
    shareModalOpen, setShareModalOpen,
  }} >
    { children }
  </QueriesCtx.Provider>
}

export {
  defaultSavedQuery,

  // ListModal,
  ListsModal,

  /* sg */
  ImportListModal,
  QueryModal,
  // QueryCloneModal,

  /* pl */
  QueriesCtx,
  QueriesModal,
  QueriesProvider,

}

